import React from "react";

import { useState, useContext } from "react";
import Swal from "sweetalert2";
import { LanguageContext } from "App";
// @mui material components
import Api from "../../Classes/API/UsersApi";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MDInput from "components/MDInput";
import CardHeader from "@mui/material/CardHeader";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CreateTherapistEmployeeTypeReq from "Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq";
const CreateTherapistType = () => {
  const [TherapistTypeName, SetTherapistTypeName] = useState("");
  const [TherapistTypeHourlyRate, SetTherapistTypeHourlyRate] = useState("");
  const [ErrorText, SetErrorText] = useState(false);
  const [Req, SetReq] = useState({});
  const { translations } = useContext(LanguageContext);
  const submitForm = async () => {
    if (!TherapistTypeName || !TherapistTypeHourlyRate) {
      if (!TherapistTypeName) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterTherapistTypeName,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      if (!TherapistTypeHourlyRate) {
        Swal.fire({
          title: "error",
          text: translations.PleaseEnterTherapistTypeHourlyRate,
          icon: "error",
          confirmButtonText: "ok",
        });
        return;
      }
      SetErrorText(true);
      return;
    }
    let req = new CreateTherapistEmployeeTypeReq();
    req.TypeName = TherapistTypeName;
    req.StandardHourlyRate = TherapistTypeHourlyRate;
    await Api.CreateNewTherapistType(req).then((response) => {
      if (response.status == "Success") {
        Swal.fire({
          title: "Success",
          text: "Therapist Type Created Successfully",
          icon: "success",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Failed",
          text: "Therapist Type Creation Failed",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
    });
  };

  return (
    <div>
      <DashboardLayout>
        {/* Page Title */}
        <DashboardNavbar />

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader
              className="mb-2"
              title={translations.EmployeeTypetableCreateTherapistType}
            ></CardHeader>
            <div className="container-fluid">
              {/* <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
                <div className="row">
                  {/* Therapist type name 
                <div className="col-md-4">
                  <MDInput className="full-width" label={translations.EmployeeTypetableCreateTherapistType} onChange={(e) => SetTherapistTypeName(e.target.value)} fullWidth />
                </div>

                  <div className="col-md-4">
                    <TextField
                      className="full-width"
                      label={translations.EmployeeTypeTherapistTypeHourlyRate}
                      type="number"
                      onChange={(e) => SetTherapistTypeHourlyRate(e.target.value)}
                      fullWidth
                    />
                  </div>
                </div>

                <div className="text-right mt-3 ">
                  <Button
                    className="white"
                    sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                    size="medium"
                    onClick={submitForm}
                  >
                    {translations.EmployeeTypetableSave}
                  </Button>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </DashboardLayout>
    </div>
  );
};

export default CreateTherapistType;
